<fieldset>
  <div class="ds-orderform-product-list" [attr.data-e2e]="'order:productlist'">
    <table
      class="table2"
      [orderformBreakpoint]="{ '439': 'table-small' }"
      orderformBreakpointOperator="<"
      *ngIf="productListSettings$ | async as productListSettings"
    >
      <thead>
        <tr>
          <th class="col col-product" i18n="@@product-list.header.product">
            Produkt
          </th>
          <th class="col col-details"></th>
          <th
            *ngIf="showAmount$ | async"
            class="col col-quantity hide-on-small"
            i18n="@@product-list.header.product_quantity"
            >Menge
          </th>
          <th
            class="col col-price"
            i18n="@@product-list.header.product_price"
            *ngIf="showPriceColumn$ | async"
            >Preis
          </th>
        </tr>
      </thead>
      <tbody [formGroup]="form">
        <ng-container
          *ngFor="
            let product of productList$ | async;
            trackBy: trackByProductId;
            let index = index;
            let l = last
          "
          formArrayName="items"
        >
          <ng-container [formArrayName]="index">
            <ng-template
              #quantSelect
              let-showSelectLabel="showSelectLabel"
              let-type="type"
            >
              <div
                [attr.data-e2e]="'order:productlist:item:quantity_select'"
                formGroupName="quantity"
              >
                <orderform-quantity-input
                  formControlName="value"
                  [showPreQuantity]="showPreQuantity$ | async"
                  [product]="product"
                  [mainProduct]="mainProduct$ | async"
                  [showQuantitySelectLabel]="showSelectLabel"
                  [radioButtonGroupName]="uniqueId + '-quantity-' + type"
                ></orderform-quantity-input>
              </div>
            </ng-template>

            <ng-template #productTitle>
              <span class="hidden" itemprop="productID">{{
                product.product_id
              }}</span>
              <h3
                itemprop="name"
                class="product-headline"
                [attr.data-e2e]="
                  'order:productlist:item:id:' + product.product_id
                "
                >{{ product.headline }}
                <img
                  alt="Warn"
                  *ngIf="product.have_warning"
                  width="18"
                  height="15"
                  [title]="product.warning_message"
                  [src]="'orderform-widgets/icons/warning.svg' | orderformAsset"
                />
              </h3>

              <orderform-quantity-discount
                class="d-block mb-3"
                [productId]="product.product_id"
              ></orderform-quantity-discount>
              <div
                class="flex items-center"
                *ngFor="let form of product.customForms"
              >
                <ng-container
                  *var="
                    form.no +
                    '-form-' +
                    product.product_id as customFormOnProductVisibleKey
                  "
                >
                  <orderform-inputs-generator
                    excludeFromOrderValidation="true"
                    (dataChanges)="
                      setCustomFormOnProduct(
                        product.product_id,
                        form.no,
                        customFormOnProductVisibleKey,
                        $event
                      )
                    "
                    [data]="
                      customFormOnProductFilled$[customFormOnProductVisibleKey]
                        | async
                    "
                    [fields]="form.fields"
                  ></orderform-inputs-generator>
                </ng-container>
              </div>
            </ng-template>

            <ng-template #plainPriceView>
              <ng-container *ngIf="productListSettings.have_plain_price_view">
                <div class="vat-note" i18n="@@order_summary.vat_included"
                  >Einschließlich Mehrwertsteuer
                </div>
              </ng-container>
            </ng-template>

            <ng-template #productOptions>
              <div
                class="mb-2"
                *ngIf="product.have_eticket"
                [attr.data-e2e]="'order:productlist:item:eticket'"
              >
                <div
                  class="input"
                  [innerHTML]="product.eticket.template | sanitize : 'HTML'"
                ></div>
                <select
                  formControlName="eticket_date_id"
                  #eticketInputComponent
                  class="form-control"
                >
                  <option
                    *ngIf="product.eticket.options.length > 1"
                    [ngValue]="null"
                    i18n="@@product-list.please_select_option"
                    >Bitte wählen ...
                  </option>
                  <option
                    *ngFor="
                      let option of product.eticket.options;
                      trackBy: trackByOptionId
                    "
                    [ngValue]="option.id"
                    >{{ option.label }}</option
                  >
                </select>
              </div>

              <div
                class="mb-2"
                *ngIf="product.have_variant"
                [attr.data-e2e]="'order:productlist:item:variants'"
              >
                <div
                  class="input"
                  [innerHTML]="product.variant.template | sanitize : 'HTML'"
                ></div>
                <select
                  formControlName="variant_id"
                  #variantInputComponent
                  class="form-control"
                >
                  <option
                    *ngIf="product.variant.options.length > 1"
                    [ngValue]="null"
                    i18n="@@product-list.please_select_option"
                    >Bitte wählen ...
                  </option>
                  <option
                    *ngFor="
                      let option of product.variant.options;
                      trackBy: trackByOptionId
                    "
                    [ngValue]="option.id"
                    [disabled]="option.label.disabled"
                  >
                    <ng-container
                      *ngIf="!option.label.disabled; else disabledVariantOption"
                    >
                      {{ option.label }}
                    </ng-container>
                    <ng-template #disabledVariantOption>
                      {{ option.label.label }}
                    </ng-template>
                  </option>
                </select>
              </div>
            </ng-template>

            <tr class="vertical-presenation" *ngIf="index === 0">
              <td colspan="10">
                <div>
                  <div class="text-center">
                    <img
                      class="mw-100 d-inline-block product-image"
                      alt="Product image"
                      [src]="product.image_url"
                      itemprop="image"
                    />
                    <ng-container
                      *ngTemplateOutlet="productTitle"
                    ></ng-container>
                  </div>

                  <ng-container
                    *ngTemplateOutlet="productOptions"
                  ></ng-container>

                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <div class="d-flex align-items-end">
                        <ng-container
                          *ngTemplateOutlet="
                            quantSelect;
                            context: { showSelectLabel: true, type: 'vertical' }
                          "
                        ></ng-container>
                      </div>
                    </div>
                    <div class="w-100"></div>
                    <div class="text-right" *ngIf="showPriceColumn$ | async">
                      <orderform-product-price
                        [product]="product"
                        [withoutInterval]="
                          productListSettings.have_plain_price_view
                        "
                        [showDiscount]="showDiscountOnItem$ | async"
                        display="total_amounts"
                        displayDiscount="total_amounts_undiscounted"
                      ></orderform-product-price>
                      <ng-container
                        *ngTemplateOutlet="plainPriceView"
                      ></ng-container>
                    </div>
                  </div>

                  <div
                    itemprop="description"
                    class="mt-3 product-description"
                    [attr.data-e2e]="'order:productlist:item:description'"
                    [innerHTML]="
                      getProductDescription(product) | sanitize : 'HTML'
                    "
                  ></div>
                </div>
              </td>
            </tr>
            <tr
              class="horizontal-presenation horizontal-presenation-item-{{
                index
              }}"
              itemscope
              itemtype="http://schema.org/Product"
              [attr.data-e2e]="'order:productlist:item:' + product.product_id"
              [class.product_row]="has_wide_texts"
            >
              <td class="col col-product">
                <img
                  class="product-image"
                  alt="Product image"
                  [src]="product.image_url"
                  itemprop="image"
                />
              </td>
              <td class="col col-details">
                <div>
                  <ng-container *ngTemplateOutlet="productTitle"></ng-container>

                  <div>
                    <ng-container
                      *ngTemplateOutlet="productOptions"
                    ></ng-container>
                  </div>

                  <div class="display-on-small mb-2">
                    <div class="d-flex align-items-end">
                      <ng-container
                        *ngTemplateOutlet="
                          quantSelect;
                          context: { showSelectLabel: true, type: 'small' }
                        "
                      ></ng-container>
                    </div>
                  </div>

                  <div
                    class="product-description"
                    itemprop="description"
                    [attr.data-e2e]="'order:productlist:item:description'"
                    [innerHTML]="
                      getProductDescription(product) | sanitize : 'HTML'
                    "
                  ></div>
                </div>
              </td>

              <td
                *ngIf="showAmount$ | async"
                class="col col-quantity hide-on-small"
                formGroupName="quantity"
                [attr.data-e2e]="'order:productlist:item:quantity'"
              >
                <div>
                  <ng-container
                    *ngTemplateOutlet="quantSelect; context: { type: 'normal' }"
                  ></ng-container>
                </div>
              </td>
              <td class="col col-price" *ngIf="showPriceColumn$ | async">
                <ng-template #defaultPrice>
                  <orderform-product-price
                    [product]="product"
                    [withoutInterval]="
                      productListSettings.have_plain_price_view
                    "
                    [showDiscount]="showDiscountOnItem$ | async"
                    display="total_amounts"
                    displayDiscount="total_amounts_undiscounted"
                  ></orderform-product-price>
                </ng-template>

                <ng-container
                  *ngIf="
                    product.orderItem.quantity?.value === 0;
                    else defaultPrice
                  "
                >
                  <orderform-product-price
                    class="unit-price-opacity"
                    [product]="product"
                    display="unit_amounts"
                  ></orderform-product-price>
                </ng-container>

                <ng-container *ngTemplateOutlet="plainPriceView">
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</fieldset>
